module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/vector-a2a546c1c279e58de6085df54e66095d.svg";